<div id="documenttypesdiv" #documenttypesdiv class="document-types" [style.height.px]="height"></div>